import {
  SetDefaultData,
  FetchLicenseTypeRequest,
  UpdateField,
  UpdateLicenseTypeRequest,
} from '../license-types.actions'
import { getUpdateLicenseTypeState } from '../license-types.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-update-license-type',
  templateUrl: './update-license-type.component.html',
  styleUrls: ['./update-license-type.component.css'],
})
export class UpdateLicenseTypeComponent extends FormTrait implements OnInit {
  private state$: Subscription
  public isLoading: boolean
  public licenseTypeId: number

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.licenseTypeId = parseInt(this.route.snapshot.paramMap.get('id'))
    this.store.dispatch<any>(new SetDefaultData('updateLicenseType'))
    this.state$ = this.store
      .pipe(select(getUpdateLicenseTypeState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.store.dispatch<any>(new FetchLicenseTypeRequest(this.licenseTypeId))
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updateLicenseType.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateLicenseType',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
      codePrefix: 'required|max:5',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      codePrefix: 'code prefix',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateLicenseTypeRequest(this.licenseTypeId, payload),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateLicenseType',
        ),
      )
    }
  }
}
